import axios from 'axios'

// state
export const state = {
}

// getters
export const getters = {
}
// mutations
export const mutations = {
}
// actions
export const actions = {
  async postRequestPasswordResetEmail({ commit }, { email }) {
    try {
      return await axios.post(`auth/passwordResetEmail`, { email })
    } catch (e) {
    }
  },
  async postRequestPasswordReset({ commit }, data) {
    try {
      return await axios.post(`auth/passwordReset`, data)
    } catch (e) {
    }
  },
}
